import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/settingsScreen.css';
// helpers
import localizationDictionary from '../../../localization';
import {getText} from '../../../helpers/localization';
// identifiers
import {SUPPORTED_UI_ODDS_FORMAT} from '../../../constants/identifiers';
// actions
import {changeOddsType, changeSystemLanguage} from '../../../actions/settingsActions';
import {setVideoVisibility} from '../../../actions/systemActions';
// configurations
import {OPERATOR} from "../../../constants/operator";

const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage,
        isVideoVisible: state.vpp.isVideoVisible
    };
};

class SettingsScreen extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isModalOpen: storeData.vpp.isModalOpen,
            openModalType: storeData.vpp.openModalType,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage,
            isVideoVisible: storeData.vpp.isVideoVisible
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState(
            {
                isModalOpen: storeData.vpp.isModalOpen,
                openModalType: storeData.vpp.openModalType,
                selectedOddsType: storeData.vpp.selectedOddsType,
                systemLanguage: storeData.vpp.systemLanguage,
                isVideoVisible: storeData.vpp.isVideoVisible
            }
        );
    }

    _languageSelectionChanged(language) {
        this.props.store.dispatch(changeSystemLanguage(this.props.store.getState().vpp.playerUID, language));
    }

    _oddsSelectionChanged(oddsType) {
        this.props.store.dispatch(changeOddsType(this.props.store.getState().vpp.playerUID, oddsType));
    }

    _showVideoSelectionChanged(newIsVideoVisible) {
        this.props.store.dispatch(setVideoVisibility(this.props.store.getState().vpp.playerUID, newIsVideoVisible));
    }

    render() {
        let store = this.props.store;
        let languagesUI = [];
        let supportedLanguages = JSON.parse(OPERATOR.supportedLanguages);

        let languagesTitleUI;
        if (OPERATOR.showLanguages) {
            if (Array.isArray(supportedLanguages) && localizationDictionary !== undefined && Object.keys(localizationDictionary).length > 0) {
                for (let i = 0; i < supportedLanguages.length; i++) {
                    Object.keys(localizationDictionary).forEach((key, index) => {
                        if (key.toString() === supportedLanguages[i]) {
                            let languageText = getText(key.toString(), store);
                            let inputRadio;
                            if (supportedLanguages.length > 1) { // when only one option is available, we only show the language text and not the option
                                inputRadio = (
                                    <input
                                        className={style.option}
                                        type='radio'
                                        name='language'
                                        value={languageText}
                                        checked={this.state.systemLanguage === key.toString() || this.state.systemLanguage.replace('-', '_') === key.toString()}
                                        onChange={() => this._languageSelectionChanged(key.toString())}/>
                                );
                            }
                            languagesUI.push((
                                <div className={style.option} key={i}
                                     onClick={() => this._languageSelectionChanged(key.toString())}>
                                    {inputRadio}
                                    <div>{languageText}</div>
                                </div>
                            ));
                        }
                    });
                }
            }

            languagesTitleUI = languagesUI.length > 0
                ? (<div className={style.title}>{getText('LANGUAGE', store)}</div>)
                : '';
        }

        let oddsUI = [];
        let supportedOddsFormats = JSON.parse(OPERATOR.supportedOddsFormats);
        // SUPPORTED_UI_ODDS_FORMAT holds DECIMAL, FRACTIONAL and AMERICAN
        if (Array.isArray(supportedOddsFormats) && SUPPORTED_UI_ODDS_FORMAT !== undefined && SUPPORTED_UI_ODDS_FORMAT.length > 0) {
            supportedOddsFormats.sort();
            for (let i = 0; i < supportedOddsFormats.length; i++) {
                SUPPORTED_UI_ODDS_FORMAT.forEach((oddsFormat) => {
                    if (oddsFormat === supportedOddsFormats[i]) {
                        oddsUI.push(
                            (
                                <div className={style.option} key={i}
                                     onClick={() => this._oddsSelectionChanged(oddsFormat)}>
                                    <input
                                        className={style.option}
                                        type='radio'
                                        name='odds'
                                        value={getText(oddsFormat, store)}
                                        checked={this.state.selectedOddsType === oddsFormat}
                                        onChange={() => this._oddsSelectionChanged(oddsFormat)}/>
                                    <div>{getText(oddsFormat, store)}</div>
                                </div>
                            )
                        );
                    }
                });
            }
        }

        let oddsTitleUI = oddsUI.length > 0
            ? (<div className={style.title}>{getText('ODDS', store)}</div>)
            : '';

        let hideVideoUI;
        if (OPERATOR.showHideVideo) {
            hideVideoUI = (
                <div>
                    <div className={style.title}>{getText('LAYOUT', store)}</div>
                    <div className={style.options}>
                        <div className={style.option}
                             onClick={() => this._showVideoSelectionChanged(!this.state.isVideoVisible)}>
                            <input
                                className={style.option}
                                type='checkbox'
                                name='show_video'
                                value={getText('SHOW_VIDEO', store)}
                                checked={this.state.isVideoVisible}
                                onChange={() => this._showVideoSelectionChanged(!this.state.isVideoVisible)}/>
                            <div>{getText('SHOW_VIDEO', store)}</div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={style.settings}>
                {languagesTitleUI}
                <div  className={`${window.innerWidth < 950 && OPERATOR.showLanguages  ? style.languageOptions:style.Options}`}>
                    {languagesUI}
                </div>
                {oddsTitleUI}
                <div className={style.options}>
                    {oddsUI}
                </div>
                {hideVideoUI}
            </div>
        );
    }
}

export default connect(mapStateToProps)(SettingsScreen);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/settingsScreen.js